<template>
	<v-dialog v-model="dialog" max-width="400px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="#800000" class="text-lowercase my-n1" icon v-on="on">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-icon small v-on="on">mdi-delete</v-icon>
					</template>
					<span>delete chain</span>
				</v-tooltip>
			</v-btn>
		</template>
		<v-card v-if="!loading">
			<v-card-title>
				<span class="subtitle-2">Would you like to delete the 
					<span class="redColor">{{ this.chain.name }}</span> chain?
				</span>
			</v-card-title>
			<v-card-text>
				<v-row justify="center" class="error">{{error}}</v-row>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="#800000" text
					class="text-capitalize" 
					@click="closeDialog">
					No
				</v-btn>
				<v-btn color="#800000" text
					class="text-capitalize"
					@click="deleteChain"
					>Yes</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: ['gameId', 'round', 'chain'],
		data () {
			return	{
				dialog: false,
				error: ''
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			}
		},
		methods: {
			async deleteChain () {
				if (!this.gameId || !this.round) {
					this.error = 'Enter game id & round, please'
				}
				else {
					try {
						//
						await this.$store.dispatch('deleteChain', {gameId: this.gameId,
							round: this.round,
							id: this.chain.id})
						this.closeDialog ()				
					}
					catch (error) {
						throw error
					}
				}
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.error = ''
			}
		}
	}
</script>
<style>
	.error{
		color: white
	}
</style>